// @ts-ignore
import ReactDOM from 'react-dom/client';
import store from "./core/store/store";
import { Provider } from 'react-redux';
import App from "./App";
import { io } from "socket.io-client";


const socket = process.env.ENV === 'dev' ? io("http://localhost:" + (process.env.PORT || 3001)) : io();

socket.on("connect", () => {
  console.log("connect", socket.id); // x8WIv7-mJelg7on_ALbx
});

socket.on("disconnect", () => {
  console.log("disconnect", socket.id); // undefined
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <App />
  </Provider>);
